<div *ngIf="isValidIndicator" class="validation-message" [ngbPopover]="tooltip" triggers="click hover" container="body" popoverClass="validation-error"><esp-icon name="circle-alert"></esp-icon></div>

<ng-container *ngIf="isParamLabelCell; else valueCell">
  <div class="param-cell">
    <span class="param-label" [class.push-right]="isValidIndicator">{{getValueToDisplay()}}</span>
    <button *ngIf="isRowEditable"
            type="button"
            class="row-edit-button"
            tabindex="-1"
            [attr.aria-label]="rowEditAriaLabel"
            [title]="rowEditTooltip"
            (click)="startRowEdit($event)"></button>
  </div>
</ng-container>
<ng-template #valueCell>
  <span [ngClass]="{'push-right':isValidIndicator}">{{params.valueFormatted}}</span>
</ng-template>

<ng-template #tooltip>
  <div class="message-text">
    <p>{{validationMessage | translate}}</p>
  </div>
</ng-template>
